import { useEffect } from 'react';
import { useIssueStore, useProjectStore } from '@/stores';
import { IssuesDashboard } from './IssuesDashboard';
import { IssuesList } from './IssuesList';
import { Loader } from '@/components/ui';

export function IssuesPage() {
  const { currentProject } = useProjectStore();
  const { 
    productIssues, 
    productionIssues, 
    dashboardData, 
    isLoading, 
    loadIssues, 
    loadDashboard 
  } = useIssueStore();

  useEffect(() => {
    if (currentProject?.id) {
      loadIssues(currentProject.id);
      loadDashboard(currentProject.id);
    }
  }, [currentProject?.id, loadIssues, loadDashboard]);

  if (!currentProject) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-gray-500">请先选择一个项目</p>
      </div>
    );
  }

  if (isLoading && productIssues.length === 0 && productionIssues.length === 0) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader size="lg" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <IssuesDashboard 
        data={dashboardData} 
        productIssues={productIssues}
        productionIssues={productionIssues}
      />
      <IssuesList />
    </div>
  );
}
